export enum Venues {
  LA_FABRIKA = "La Fabrika",
  PARALELNI_POLIS = "Paralelní Polis - Institute of Cryptoanarchy",
}